module.exports = __webpack_public_path__ + "img/mh.6d60cee3.svg";